import { defineStore } from 'pinia'
import { useGraphqlFetch } from '~/composables/craft-fetch'
import { useCacheStore } from '~/store/cache'

export const useVariantHomeDetailStore = defineStore('variant-home-detail', () => {
  const cacheStore = useCacheStore()
  const graphqlFetch = useGraphqlFetch()

  const site = ref('mijnDierIsZoek')
  const animalCounts = ref<Record<string, number>>({})

  function initialize({ site: site_ }: { site: string }) {
    site.value = site_
  }

  function setAnimalCounts(animalCounts_: Record<string, number>) {
    animalCounts.value = animalCounts_
  }

  async function fetchAnimalCounts() {
    const site_ = site.value
    const key = `variant-home-detail;animal-counts;site:${site_}`
    const ttl = 900

    const fetcher = async () => {
      const { elasticSearch } = await graphqlFetch({
        token: 'elasticsearch',
        query: `query variantHomeDetail($animalType:[String]) {
            elasticSearch(section: "animal", site: "*", animalTypeFacet: $animalType) {
              facets {
                animalCategory { value count }
              }
            }
          }`,
        variables: {
          animalType: site_ === 'mijnDierIsZoek' ? 'found' : 'available',
        },
      })

      return Object.fromEntries(elasticSearch.facets.animalCategory.map((facet) => [facet.value, facet.count]))
    }

    setAnimalCounts(await cacheStore.fetch({ key, ttl, fetcher, fallback: {} }))
  }

  return { site, animalCounts, initialize, setAnimalCounts, fetch: fetchAnimalCounts }
})
